import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class RegistruService {
    private basePath = environment.interop.basePath;
    private getRegistreUrl = this.basePath + environment.interop.indoc.registru.getRegistre;
    public downloadTabel = this.basePath + environment.interop.indoc.registru.downloadTabel;

    constructor(private http: HttpClient) { }

    listRegistre() {
        return this.http.get(this.getRegistreUrl);
    }
}
